// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'
import { ShiftsCreationAreaId } from './ShiftsCreationAreaId'
import { ShiftsCreationAreaNavigation } from './ShiftsCreationAreaNavigation'
import { ShiftsCreationAreaRoutes } from './ShiftsCreationAreaRoutes'

const LazyShiftsCreationComponent = lazy(() => import('./ShiftsCreationArea'))

const ShiftsCreationComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyShiftsCreationComponent />
  </SuspenseLoadingWrapper>
)

export const ShiftsCreationArea = {
  id: ShiftsCreationAreaId,
  requiredRight: BoumRight.AREA_EMPLOYEE_SHIFT_CREATION_TOOL,
  NavigationComponent: ShiftsCreationAreaNavigation,
  route: {
    path: ShiftsCreationAreaRoutes.route,
    component: ShiftsCreationComponent,
  },
}
